<div class="replace-matcard">
  <h1>{{datamanagement?.title}}</h1>
  <div class="table-container">
    <table mat-table [dataSource]="dataSourceBaseData">
      <ng-container matColumnDef="regionName">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{datamanagement?.col1Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.regionName}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="regionCreation">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{datamanagement?.col2Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.regionCreation | date}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="regionState">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{datamanagement?.col3Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.stateName}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="regionActions">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{datamanagement?.col4Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <label *ngIf="element.isDefaultRegion" title="{{'Default region'}}">
            <button mat-raised-button class="default color">D</button>
          </label>
          <label *ngIf="!element.isDefaultRegion" title="{{'Set as default region'}}">
            <button mat-raised-button class="default" (click)="setAsDefaultRegionDialog(element.id)">D</button>
          </label>
          <mat-icon *ngIf="element.stateId === 0" class="openCell" title="{{datamanagement?.action7}}"
            (click)="showRegion(element.id)">pageview</mat-icon>
          <mat-icon *ngIf="element.stateId === 1 " class="openCell" title="{{datamanagement?.action1}}"
            (click)="openEditor(element.id)">edit</mat-icon>
          <mat-icon *ngIf="element.stateId === 1 " class="openCell" title="{{datamanagement?.action6}}"
            (click)="openFileImportDialog(element.id)">description</mat-icon>
          <mat-icon *ngIf="element.stateId === 5" class="openCell" title="{{datamanagement?.action4}}"
            (click)="openView(element.id)">forward</mat-icon>
          <mat-icon *ngIf="element.stateId === 0 || element.stateId === 1" class="openCell"
            title="{{datamanagement?.action2}}" (click)="openCopyAsNewRegionDialog(element.id)">fiber_new</mat-icon>
          <mat-icon *ngIf="element.stateId === 1" class="openCell" title="{{datamanagement?.action5}}"
            (click)="showPublishDialog(element.id)">publish</mat-icon>
          <mat-icon *ngIf="!element.isDefaultRegion" class="delete" title="{{datamanagement?.action3}}"
            (click)="showDeleteDialog(element.id)">cancel</mat-icon>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="openProject"></tr>
    </table>
  </div>
</div>
<hr class="line">